/* eslint-disable no-bitwise */
import moment from 'moment';
import dayjs from 'dayjs';
import { get } from '../libs/Axios';
import BaseComponent from '../abstracts/BaseComponent';
import RentCalendarComponent from './RentalCalendarComponent';
import { DataLayerUtils } from '../utilities/DataLayer';

export default class RentalConfigsComponent extends BaseComponent {
  get Messages() {
    return {
      [this.CUSTOM_MESSAGES.CALENDAR_MODAL_EVENTS.rangeSetted]: this.setValue,
      [this.CUSTOM_MESSAGES.MODAL_EVENTS.afterOpen]: this.initModal,
      [this.CUSTOM_MESSAGES.MODAL_EVENTS.afterClose]: this.destroyModal,
      [this.CUSTOM_MESSAGES.SELECT_SIZE_EVENTS.selected]: this.sizeSelected,
      [this.CUSTOM_MESSAGES.ADDTOCART_EVENTS.erros]: this.showModal,
      [this.CUSTOM_MESSAGES.RENT_DURATION_EVENTS.get]: this.emitDuration
    };
  }

  get PARENT() {
    return this.$el.closest('.js-render-price');
  }

  get SELECTORS() {
    return {
      input: '.js-range-start',
      displayValue: '.js-range-value',
      displayValueMobile: '.js-range-value-mobile',
      applyConfigs: '.js-apply-configs',
      closeConfigs: '.js-close-configs-modal',
      calendar: '.js-calendar',
      duration: '.js-duration',
      rentalSummary: '.js-rental-summary',
      deliveryValue: '.js-delivery-value',
      returnValue: '.js-return-value',
      rentalDuration: '.js-rental-duration',
      sizeValue: '.js-product-size',
      priceModal: '.js-price-modal'
    };
  }

  sizeSelected({ sizeSelected }) {
    this.sizeSelected = true;
    this.sizeSelectedValue = sizeSelected;
  }

  constructor(element) {
    super(element);
    const { rentalstartdate, rentalperiod } = this.$options;
    this.sizeSelected = false;
    this.dateSummary = this.$el.querySelector(this.SELECTORS.input);
    this.EMIT(this.CUSTOM_MESSAGES.ADDTOCART_EVENTS.waitForMe, {
      component: 'RentalConfigsComponent'
    });
    this.handleRadioChange();

    if (rentalperiod || rentalstartdate) {
      this.getEndDate(rentalstartdate).then(({ endDate }) => {
        this.setValue({
          rangeStart: rentalstartdate,
          rangeStartString: dayjs(Number(rentalstartdate)).format('DD.MM.YYYY'),
          rangeEndString: dayjs(endDate).format('DD.MM.YYYY')
        });
      });
    }

    this.setPrice();
    this.emitDuration();
  }

  showModal() {
    if (this.sizeSelected) this.EMIT(this.CUSTOM_MESSAGES.MODAL_EVENTS.show, { selector: this.$options.modal });
  }

  destroyModal() {
    if (this.calendar) {
      this.calendar._destroy();
      this.calendar.picker.destroy();
      delete this.calendar;
    }
  }

  initModal({ vexInstance }) {
    try {
      const modal = vexInstance.contentEl;
      const calendar = modal.querySelector(this.SELECTORS.calendar);
      const duration = modal.querySelector(this.SELECTORS.duration);
      // if rental calendar modal
      if (calendar && duration) {
        const sizeValue = modal.querySelector(this.SELECTORS.sizeValue);
        this.initCalendar(calendar);
        this.handleRadioChange(duration);
        this.bindActions(modal);

        if (this.sizeSelectedValue) {
          sizeValue.parentElement.classList.remove('hide');
          sizeValue.innerHTML = this.sizeSelectedValue;
        } else {
          sizeValue.parentElement.classList.add('hide');
        }

        DataLayerUtils.push({
          gaHitType: 'event',
          event: 'pdp_interactions',
          eventCategory: 'pdp',
          eventAction: 'choose_delivery_date',
          eventLabel: 'on/off',
        });

        DataLayerUtils.push({
          gaHitType: 'event',
          event: 'virtual_page_view',
          eventCategory: 'popup',
          eventAction: 'select_delivery_date'
        });
      }
    } catch (e) {
      console.error(e);
    }
  }

  async initCalendar(el) {
    this.calendar = new RentCalendarComponent(el, this.$options.enddateurl);
    if (this.radioInfo) this.calendar.baseRange = this.getRentalDuration();
    if (this.dateSummary.value) this.calendar.setRange(this.dateSummary.value);
  }

  async getEndDate(startDate) {
    let res;
    try {
      const { data } = await get(this.$options.enddateurl, {
        params: {
          startDateTimestamp: isNaN(startDate) ? moment(startDate).format('x') : Number(startDate),
          range: this.getRentalDuration()
        }
      });
      res = data;
    } catch (e) {
      console.error(e);
    }

    return res;
  }

  emitDuration() {
    const durationSelected = [...this.$el.querySelectorAll('input[type="radio"]')].find(radio => radio.checked);
    this.EMIT(this.CUSTOM_MESSAGES.RENT_DURATION_EVENTS.changed, {
      value: durationSelected.value
    });
  }

  async handleRadioChange(el) {
    const durationSelected = [...this.$el.querySelectorAll('input[type="radio"]')].find(radio => radio.checked);
    this.EMIT(this.CUSTOM_MESSAGES.RENT_DURATION_EVENTS.changed, {
      value: durationSelected.value
    });

    this.radioInfo = {
      value: durationSelected.value,
      element: this.$el
    };

    if (el) {
      let radio = el.querySelector('input[type="radio"]');
      if (this.radioInfo) {
        radio = el.querySelector(`[value='${this.radioInfo.value}']`);
        radio.checked = true;
        this.EMIT(this.CUSTOM_MESSAGES.RENT_DURATION_EVENTS.changed, {
          value: this.radioInfo.value
        });
      }
    }
    this.$on(
      'change.duration',
      async (e) => {
        this.setDurationInfo(e);
        if (!el && this.dateSummary.value) {
          const startDate = isNaN(this.dateSummary.value) ? this.dateSummary.value : Number(this.dateSummary.value);
          const { endDate } = await this.getEndDate(startDate);
          this.setValue({
            rangeStart: startDate,
            rangeStartString: dayjs(startDate).format('DD.MM.YYYY'),
            rangeEndString: dayjs(endDate).format('DD.MM.YYYY')
          });
        }
      },
      el || this.$el.querySelector(this.SELECTORS.duration)
    );
  }

  async bindActions(modal) {
    this.$on(
      'click.modal',
      () => {
        if (this.calendar.dates) this.setValue(this.calendar.dates);
        if (this.radioInfo) {
          const radio = this.$el.querySelector(`[value='${this.radioInfo.value}']`);
          if (radio) radio.checked = true;
        }
        this.EMIT(this.CUSTOM_MESSAGES.MODAL_EVENTS.close);
        if ((this.dateSummary && this.dateSummary.value) && (this.radioInfo && this.radioInfo.value)) {
          this.EMIT(this.CUSTOM_MESSAGES.RENT_CALENDAR_EVENTS.rangeSetted, {
            component: 'RentalConfigsComponent',
            duration: this.radioInfo ? this.radioInfo.value : '',
            startDate: this.dateSummary.value || ''
          });
        }

        var duration = this.radioInfo ? this.radioInfo.value : this.getRentalDuration();
        const rentalDuration = this.$el.querySelector(this.SELECTORS.rentalDuration);
        rentalDuration.innerHTML = `${duration}`;

        this.setPrice();

        // DataLayerUtils.push({
        //   gaHitType: 'event',
        //   event: 'popup_interactions',
        //   eventCategory: 'popup',
        //   eventAction: 'apply',
        //   eventLabel: 'on',
        // });
      }, modal.querySelector(this.SELECTORS.applyConfigs)
    );
    this.$on('click.modal', () => {
      this.calendar.picker.reset();
      const btn = document.querySelector(this.SELECTORS.applyConfigs);
      btn.disabled = true;
      const pdpRentalCta = document.querySelector('.js-range-value');
      pdpRentalCta.innerHTML = pdpRentalCta.getAttribute('data-attribute-msg');
      this.dateSummary.value = '';
      this.EMIT(this.CUSTOM_MESSAGES.ADDTOCART_EVENTS.waitForMe, {
        component: 'RentalConfigsComponent'
      });
      // this.calendar.picker.destroy();
      DataLayerUtils.push({
        gaHitType: 'event',
        event: 'popup_interactions',
        eventCategory: 'popup',
        eventAction: 'click',
        eventLabel: 'cancel'
      });
    }, modal.querySelector(this.SELECTORS.closeConfigs));
  }

  getRentalDuration() {
    const duration = this.$el.querySelector(this.SELECTORS.duration);
    const selectedInput = [...duration.querySelectorAll('input')].filter(input => input.checked);

    return selectedInput[0].value;
  }

  async setDurationInfo(event) {
    const selectedInput = [...event.currentTarget.querySelectorAll('input')].find(input => input.checked);
    this.radioInfo = {
      value: selectedInput.value,
      element: this.$el
    };

    if (this.calendar) this.calendar.baseRange = this.radioInfo.value;

    this.EMIT(this.CUSTOM_MESSAGES.RENT_DURATION_EVENTS.changed, {
      value: selectedInput.value
    });
    this.setPrice();
    this.setModalPrice(selectedInput.value);
  }

  async setValue({ rangeStart, rangeStartString, rangeEndString }) {
    const displayValue = this.$el.querySelector(this.SELECTORS.displayValue);
    const displayValueMobile = this.$el.querySelector(this.SELECTORS.displayValueMobile);
    const deliveryValue = this.$el.querySelector(this.SELECTORS.deliveryValue);
    const returnValue = this.$el.querySelector(this.SELECTORS.returnValue);
    const rentalDuration = this.$el.querySelector(this.SELECTORS.rentalDuration);
    const rentalSummary = this.$el.querySelector(this.SELECTORS.rentalSummary);


    const timestamp = isNaN(rangeStart) ? new Date(rangeStart).getTime() : rangeStart;
    var duration = this.getRentalDuration();

    rentalDuration.innerHTML = `${duration}`;
    displayValue.innerHTML = `${rangeStartString}<i class="icon-chevron-right"></i>${rangeEndString}`;
    displayValueMobile.innerHTML = displayValueMobile.getAttribute('data-attribute-msg');
    deliveryValue.innerHTML = `${rangeStartString}`;
    returnValue.innerHTML = `${rangeEndString}`;
    this.dateSummary.value = timestamp;
    rentalSummary.classList.remove('hide');
  }

  setPrice() {
    var duration = this.getRentalDuration();
    if (Number(duration) === 4) {
      this.PARENT.classList.remove('high');
      this.PARENT.classList.add('low');
    } else if (Number(duration) === 8) {
      this.PARENT.classList.remove('low');
      this.PARENT.classList.add('high');
    }
  }

  setModalPrice(d) {
    var duration = d || 4;
    var priceModal = document.querySelector(this.SELECTORS.priceModal);
    if (Number(duration) === 4) {
      priceModal.classList.remove('high-modal');
      priceModal.classList.add('low-modal');
    } else if (Number(duration) === 8) {
      priceModal.classList.remove('low-modal');
      priceModal.classList.add('high-modal');
    }
  }
}
